import React from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const LogInBG = () => {
  let location = useLocation();
  const { companyInfo } = useAuth();
  const [searchParams] = useSearchParams();
  const parentAgency = searchParams.get("agency") || null;

  return (
    <div
      className="form-grid_right"
      style={{ backgroundImage: "url('images/login-bg.jpg')" }}
      // style="background-image: url(images/login-bg.svg);"
    >
      <div className="form-right-img-block login">
        <div className="btn-grid">
          <Link className="cta-primary" to="/signup">
            Sign Up
          </Link>
          {/* {!parentAgency && <Link
                        className="cta-primary"
                        to="/admin/login"
                    >
                        Administrator Sign In
                    </Link>} */}
        </div>
        <header>
          <h2>
            <span>Unlock</span> the power of
          </h2>
          <h3>
            {!!parentAgency ? companyInfo?.orgName : "BottBuddy"} AI Chatbot
          </h3>
        </header>
        {/* <figure>
                    <img src="/images/Bot-AvatarGreenXparent.png" alt />
                </figure> */}
      </div>
    </div>
  );
};
export default LogInBG;
